// extracted by mini-css-extract-plugin
export default {"flexWrapper":"LoginModal_flexWrapper__Ju5-0","btn":"LoginModal_btn__l+Ed2"};